// Topbar.js
import React from 'react';
import Cookies from 'js-cookie';
import GTranslate from '../GTranslateInline';
import { useNavigate } from 'react-router-dom';

const Topbar = () => {
  const navigate = useNavigate();

  const resetTutorial = () => {
    Cookies.remove('user_seen_tutorial');
    Cookies.remove('tutorial_step_index');
    window.location.href = '/';
  };

  return (
    <div className="topbar">
      <div className="container-topbar">
        <div className="">
          <div className="">
            <div>
              <span className="banner-text" style={{ color: '#f1f5f9' }}>
              <button 
  onClick={() => navigate('/about-us')} 
  className="btn btn-sm d-none d-md-inline mr-1 a-btn">
  <span>About Us</span>
</button>

<button 
  onClick={() => navigate('/blogs')} 
  className="btn btn-sm d-none d-xl-inline mr-1 a-btn">
  <span>Blog</span>
</button>

<button 
  onClick={() => navigate('/contact-us')} 
  className="btn btn-sm mr-1 a-btn">
  <span>Contact Us</span>
</button>

              </span>
            </div>
          </div>
        </div>

        <div className="info-topbar text-center d-none d-md-inline">
          <span className="color-brand-3">
            <strong className="banner-text d-none d-xl-inline">The Fastest B2B Network in Pakistan.</strong>
            <span className="banner-text d-none d-md-inline" style={{ color: '#f1f5f9' }}>
              Need help? Call Us: <a href="tel:+922137295237"><span className="font-sm-bold banner-text d-none d-md-inline">02137295237</span></a>
            </span>
          </span>
        </div>

        <div className="">
          <div className="widget-header mr-1">
            <GTranslate />
          </div>
          <div className="widget-header mr-1">
            <button onClick={resetTutorial} className="btn btn-sm a-btn">
              <span className="d-none d-sm-inline">View </span>Tutorial
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Topbar;
